import { render, staticRenderFns } from "./num-input.vue?vue&type=template&id=8858a054&lang=html&"
import script from "./num-input.vue?vue&type=script&lang=js&"
export * from "./num-input.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports